const useCases = [
  { title: 'New leads', description: 'Call fresh inquiries within 30 seconds, qualify interest, and book appointments.' },
  { title: 'Old leads', description: 'Reconnect with your database and turn past conversations into new opportunities.' },
  { title: 'FSBO & expired', description: 'Reach motivated sellers with consistent outreach and follow-up.' },
  { title: 'Open houses', description: 'Follow up with attendees, qualify interest, and book the next showing.' },
];

export default function RealEstateUseCases() {
  return (
    <section className="py-8 sm:py-12 bg-white" aria-labelledby="use-cases-title">
      <div className="max-w-5xl mx-auto px-6">
        <h2 id="use-cases-title" className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 mb-6">What it handles</h2>
        <div className="grid sm:grid-cols-2 gap-x-12">
          {useCases.map(item => (
            <div key={item.title} className="border-t border-gray-200 py-4">
              <h3 className="text-lg font-semibold text-gray-900 mb-1">{item.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
